import { Typography } from "@codat/orchard-ui";

import styles from "./CardHeader.module.css";

interface HeaderProps {
  title: string;
  subtitle?: string;
  icon?: JSX.Element;
  skeleton?: boolean;
}

const CardHeader = ({
  title,
  subtitle,
  icon,
  skeleton = false,
}: HeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.row}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <Typography
          isSkeleton={skeleton}
          variant="heading_xl"
          as="h3"
          className={styles.pageTitle}
        >
          {title}
        </Typography>
      </div>
      {subtitle && (
        <Typography
          isSkeleton={skeleton}
          variant="body_lg"
          as="h3"
          className={styles.pageSubtitle}
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default CardHeader;
